var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'ml-' + _vm.margin},[_vm._v(_vm._s(_vm.element.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }